export enum PaymentTermKind {
	PAYMENT = 'P',
	REFUND = 'R',
	COMMISSION = 'C',
}

export const PAYMENT_TERM_KIND_LABELS: Record<PaymentTermKind, string> = {
	[PaymentTermKind.PAYMENT]: 'Termin płatności',
	[PaymentTermKind.REFUND]: 'Termin zwrotu',
	[PaymentTermKind.COMMISSION]: 'Termin prowizji',
};

export const PAYMENT_TERM_KIND_OPTIONS = [
	{ id: PaymentTermKind.PAYMENT, name: PAYMENT_TERM_KIND_LABELS[PaymentTermKind.PAYMENT] },
	{ id: PaymentTermKind.REFUND, name: PAYMENT_TERM_KIND_LABELS[PaymentTermKind.REFUND] },
	{ id: PaymentTermKind.COMMISSION, name: PAYMENT_TERM_KIND_LABELS[PaymentTermKind.COMMISSION] },
] as const;
